module.exports = __webpack_public_path__ + "images/fontello.svg";


//////////////////
// WEBPACK FOOTER
// ./~/mavon-editor/dist/font/fontello.svg
// module id = 946
// module chunks = 2